export default "__VITE_ASSET__ce145e50__"